import { MobileMenu } from './parts/mobile-menu.js';

import './parts/search';
import './parts/sliders.js';

document.addEventListener("DOMContentLoaded", () => {

	// Init Mmenu Light
	MobileMenu( "responsive-menu" );


});